import lang from "element-ui/lib/locale/lang/zh-CN"; // 引入element语言包
const messages = {
  极兔开放平台: "极兔开放平台",
  帮助中心: "帮助中心",
  '注 册': "注 册",
  "快递轨迹查询": "快递轨迹查询",
  "新增订单": "新增订单",
  "取消订单": "取消订单",
  "查询订单": "查询订单",
  "打印订单": "打印订单",
  "物流轨迹订阅（新）": "物流轨迹订阅（新）",
  "物流轨迹回传": "物流轨迹回传",
  "订单状态回传": "订单状态回传",
  "退回件申请": "退回件申请",
  indexPage: {
    title: "快递服务技术对接平台",
    BannerTxt: "共享极兔各类服务接口，实现物流供应链一体化，帮助企业高效完成快递寄件、信息跟踪，提供快件信息安全的增值服务。实现与极兔的高效合作。",
    BannerBtnTxt: "加入极兔开放平台",
  },
  helpCenter: {
    常用工具: "常用工具",
    签名工具: "签名工具",
    电子面单模板: "电子面单模板",
    "API-SDK说明": "API-SDK说明",
    签名方式:"签名方式",
    method_1:"1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;",
    method_2:"2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再base64加密;",
    method_3:"3. 例如：base64(MD5({“age”:18,”gender”:”male”,”name”:”张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。",
    method_4:"4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。",
    method_5:"5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；",
    method_6:"6. 部分接口示例代码和sdk请参考示例代码、SDK文档。",
    业务参数签名:"业务参数签名",
    请输入加密后的32位pwd:"请输入加密后的32位pwd",
    获取:"获取",
    Headers签名:"Headers签名",
    bussness:`示例：在调用下单、取消订单等接口时，需要业务参数<code>digest</code>，而业务参数<code>digest</code>跟全局Headers里面的<code>digest</code>含义不一样。`,
    bussness_1:`首先，极兔会分配一个协议客户下单所需的账号和密码。例如：<code>J0086024071</code>/<code>BaMCAx11</code>,其中<code>pwd</code>等于<code>MD5(明文密码(BaMCAx11)+jadada236t2)</code>
    后大写,比如此示例生成的32位<code>pwd</code>为<code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>,最后按照规则Base64(Md5(客户编号+密文+privateKey))生成业务参数签名。`,
    bussness_2:`即：业务参数签名<code>digest</code>=Base64(Md5(<code>J0086024071</code>+<code>A023DEEDCE52B0FD92A3EE1E9F74FD2B</code>+privateKey))`,
    headers_1:`示例：以取消订单为例：假设业务参数为  bizContent为<code>{"txlogisticId":"SA71398747473","orderType":2,"reason":"jiushixiangquxiaoyouruhe","customerCode":"J0086024071"}</code>,那么此时的header里面的签名digest等于<code>base64(md5(业务参数的Json+privateKey))</code>,`,
    headers_2:`即 <code>base64(md5({"txlogisticId": "SA71398747473", "orderType": 2, "reason": "jiushixiangquxiaoyouruhe", "customerCode": "J0086024071", "digest": "4hQ8qXNkuSJ8cIgJQDFFRA=="}+privateKey))</code>。`,
    headers_3:`注：<code>privateKey</code>为账号通过平台认证后自动分配`,
    一联模版:"一联模版",
    "API开放平台-SDK":"API开放平台-SDK",
    "Introduction":"一、简介",
    "sdk_two":"二、版本更新记录",
    "sdk_3_title":"三、快速入门 安装API开放平台 SDK",
    "sdk_4_title":"四、API-SDK目录结构",
    "sdk_5_title":"五、直接使用JAR包步骤如下：",
    "sdk_6_title":"六、SDK相关maven依赖",
    "sdk_7_title":"七、创建JtExpressApi",
    "sdk_8_title":"八、建议",
    "Introduction_1":"Hi，您好，欢迎使用API开放平台。",
    "Introduction_2":"本文档主要针对平台开发者，描述快递服务技术对接平台的相关技术内容。如果您对文档内容有任何疑问，可以联系平台运营解答疑问。",
    date:"日期",
    sdkVersion:"版本号",
    updata:"更新内容",
    updataInfo:"提供了调用开放平台接口的通用标准，辅助完成接口的签名",
    "语言":"语言",
    最新版本:"最新版本",
    项目示例:"项目示例",
    开发环境:"开发环境",
    "支持JAVA版本":"支持 JAVA版本：1.8+",
    "支持PHP":"支持 PHP7.0及以上",
    签名相关类:"签名相关类",
    公用类:"公用类",
    异常相关类:"异常相关类",
    Http通信相关类:"Http通信相关类",
    开放平台api通用接口:"开放平台api通用接口",
    执行器接口:"执行器接口",
    sdk_5_txt:`<p>1.SDK压缩工具包由开放平台提供。</p>
    <p>2.将开放平台提供的"jt-openapi-sdk.zip"解压后，复制到工程文件夹中。</p>
    <p>3.点击 File -> Project Structure（快捷键 Ctrl + Alt + Shift + s），点击Project Structure界面左侧的“Modules。</p>
    <p>4.在 “Dependencies” 标签界面下，点击右边的 “+”号，选择第一个选项“JARs or directories...”，选择相应的jar包，点“OK”，jar包添加成功。</p>
    <p>5.具体接口的SDK调用方法可以下载‘示例实用项目.zip’进行参考。</p>`,
    sdk_6_txt:"SDK默认使用slf4j-api包进行日志输出;SDK默认使用fastjson进行json数据转换；SDK默认使用httpclient进行http数据传输。",
    sdk_7_txt:`<p>JtExpressApi是极兔开放平台api通用执行器,为使用极兔开放平台的开发人员提供了一系列的交互方法。</p>
    <p>用户可以参考如下代码新建一个JtExpressApi,初始化完成后建议单例使用,避免重复创建:</p>`,
    sdk_8_txt:`<p>如果你是用springboot框架来调用API开放平台-SDK相关接口,建议把JtExpressApi放到spring容器中进行管理,</p>
    <p>用户可以参考如下代码新建一个配置类:</p>`,
  },
  controlPage:{
    "审核状态": "审核状态",
    请选择国家: "请选择国家",
    请输入酋长国: "请输入酋长国",
    请输入区域: "请输入区域",
    公司详细地址: "公司详细地址",
    请输入社会信用代码: "请输入社会信用代码",
    请上传营业执照: "请上传营业执照",
    请输入法人身份证: "请输入法人身份证",
    身份证详细地址: "身份证详细地址",
    请选择证件类型: "请选择证件类型",
  },
  message: {},
  apiDoc: {
    极兔API简介: "极兔API简介",
    订单服务: "订单服务",
    创建订单: "创建订单",
    查询订单: "查询订单",
    取消订单: "取消订单",
    订单状态回传: "订单状态回传",
    退回件申请: "退回件申请",
    '退换货接口': '退换货接口',
    散客寄件: "散客寄件",
    物流轨迹: "物流轨迹",
    物流轨迹查询: "物流轨迹查询",
    物流轨迹订阅: "物流轨迹订阅",
    物流轨迹回传: "物流轨迹回传",
    获取三段码: '获取三段码',
    API简介: "API简介",
    IntroductionContent: "为了更好的服务广大客户，极兔开放平台提供标准统一的接入API，为客户与平台直接实现数据的交互，提高双方的便利。本平台将接入的流程和步骤进行详细的描述，方便客户更快速准确的接入API平台。",
    "对接流程": "对接流程",
    process_1: "1.注册用户，注册成为极兔开放平台的一员",
    process_2: "2.申请成为开发者，完善开发者信息，成为极兔开放平台普通开发者。",
    process_3: "3.企业认证，完善企业信息，获取全部接口权限，可使用订单服务、电子面单服务等。",
    process_4: "4.联调测试，调试测试环境接口服务，与具体的接口服务人员沟通解决问题。",
    process_5: "5.发布上线，联调测试通过后，联系具体的接口服务人员，确认上线细节。",
    签名方式:"签名方式",
    method_1:"1. 使用http协议表单提交的方式进行信息交互，字符编码默认统一采用UTF-8，数据格式：application/x-www-form-urlencoded;",
    method_2:"2. apiAccount和privateKey由平台提供； digest=base64(md5(业务参数的Json+privateKey))，注：先md5得到字节数组，再base64加密;",
    method_3:"3. 例如：base64(MD5({“age”:18,”gender”:”male”,”name”:”张三”}123456)) 如签名错误，可以对url进行编码然后发送请求。",
    method_4:"4. 字段类型约定：需要严格依据字段表格中给出的参数格式和大小进行开发。",
    method_5:"5. 字段解析约定：参数字段中的必选字段是每次调用接口时都要求必须传入的；",
    method_6:"6. 部分接口示例代码和sdk请参考示例代码、SDK文档。",
    在线文档: "在线文档",
    测试工具: "测试工具",
    失败: "失败",
    Headers签名失败: "Headers签名失败",
    内部调用异常: "内部调用异常",
    apiAccount为空: "apiAccount为空",
    digest为空: "digest为空",
    timestamp为空: "timestamp为空",
    系统错误: "系统错误",
    非法参数: "非法参数",
    "面单模版查询": "面单模版查询",
    "其他服务": "其他服务",
    "三段码查询": "三段码查询",
    "面单模版查询（新）": "面单模版查询（新）",
    "快件预报": "快件预报",
    "快件预报删除": "快件预报删除",
    "航空预报": "航空预报",
    '预估运费查询': '预估运费查询',
    "代收货款订阅": "代收货款订阅",
    "代收货款回传": "代收货款回传",
    "预约派送": "预约派送",
    '出口国际件': '出口国际件',
    清关小包下发: '清关小包下发',
    清关单下发: '清关单下发',
    清关单取消: '清关单取消',
    清关单查询: '清关单查询',
    清关服务: '清关服务'
  },
  onlineDoc: {
    地址: "地址：使用接入方提供的URL",
    请求方法: "请求方法：",
    数据类型: "数据类型：",
    响应类型: "响应类型：",
    接口说明: "接口说明",
    接口信息: "接口信息",
    参数描述: "参数描述",
    Headers: "Headers",
    请求参数: "请求参数",
    业务参数: "业务参数",
    sender类型说明: "sender类型说明",
    receiver类型说明: "receiver类型说明",
    items类型说明: "items类型说明",
    customsInfo类型说明: "customsInfo类型说明",
    details类型说明: "Type description",
    报文描述: "报文描述",
    响应参数: "响应参数",
    data类型说明: "data类型说明",
    请求示例: "请求示例",
    返回示例: "返回示例",
    错误代码: "错误代码",
    错误编码: "错误编码",
    错误描述: "错误描述",
    测试地址: "测试地址：",
    正式地址: "正式地址：",
    测试apiAccount: "测试apiAccount：",
    测试privateKey: "测试privateKey：",
    属性名: "属性名",
    属性类型: "属性类型",
    是否必填: "是否必填",
    示例: "示例",
    描述: '描述',
    OrderDescription_1: "与平台签约的客户，可通过此接口创建/修改订单。目前创建订单接口支持修改订单，即如果客户订单号（txlogisticId）已存在，且对应的订单未揽件，则直接修改已有订单。如果收件地址发生变更就重新获取最新的三段码/大头笔返回；",
    OrderDescription_2: "查询新增订单接口创建的订单",
    OrderDescription_3: "取消通过新增订单接口生成的订单",
    OrderDescription_4: "接入方在提供了物流状态回传相关信息并完成了下订单操作后，当订单相关的状态变化时，系统会根据接入方配置的推送账户主动推送物流信息。",
    OrderDescription_8: "通过地址查询对应的三段码信息",
    OrderDescription_5: "非网点签约客户可通过此接口创建散客订单。目前散客寄件接口支持修改订单，即如果客户订单号（txlogisticId）已存在，且对应的订单未揽件，则直接修改已有订单。可通过“实名制信息上传”接口上传寄件用户信息；",
    "通过单号查询快件的轨迹信息": "通过单号查询快件的轨迹信息",
    OrderDescription_6: "用户通过接口可获取到电子面单的模版信息",
    OrderDescription_7: "用户通过接口可对已经取件的运单进行退件申请",
    OrderDescription_9: "退换货下单接口",
    trackDescription_1: "通过单号查询快件的轨迹信息",
    trackDescription_2: `向极兔订阅需推送物流轨迹的运单号 <br/> <strong>注意事项：需提供回传物流轨迹的URL</strong> `,
    trackDescription_2_1: `向极兔订阅需推送物流轨迹的运单号，注意事项：需提供回传物流轨迹的URL`,
    trackDescription_3: "接入方在提供了快递轨迹推送相关信息并完成了下订单操作后，当订单相关的运单轨迹变化时，系统会根据接入方配置的推送账户主动推送物流信息。",
    // 表单描述翻译
    接入方在平台的api账户标识: "接入方在平台的api账户标识",
    通过地址查询对应的三段码信息:'通过地址查询对应的三段码信息',
    签名字符串: "签名字符串",
    "时间戳，毫秒": "时间戳，毫秒",
    业务参数模块内json格式的string类型: "业务参数模块内json格式的string类型",
    "客户编码（联系出货网点提供）": "客户编码（联系出货网点提供）",
    sign: "签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写",
    signnew: "1.MD5签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写 <br />2.SHA256签名，Sha256(客户编号+密文+privateKey)，其中密文：Sha256(明文密码)",
    合作网点: "合作网点",
    "客户订单号（传客户自己系统的订单号）": "客户订单号（传客户自己系统的订单号）",
    ExpressType: "快件类型：仅支持<br/> EZ：standard（UAE)；<br/>EZKSA：standard（KSA)；<br/>Reverse: Reverse（KSA）；<br/>ReverseUAE: Reverse（UAE）<br/>SDD:Same Day（KSA）<br/>SDDUAE:Same Day（UAE）<br/>SCH: SCHEDULE（KSA）<br/>SCHUAE: SCHEDULE（UAE）<br/>BULKY: BulkyKSA (KSA)<br/>BULKY: BulkyUAE (UAE)",
    expressQueryType: "0.快递面单模板<br/>1.跨境件面单模板<br/>2.出口国际件面单模板",
    OrderType: "订单类型（有客户编号为月结）<br/>1、 散客；<br/>2、月结；",
    OrderTypeSec: "订单类型（有客户编号为月结）<br/>1、 散客；<br/>2、月结；<br/>3、出口国际件；",
    "服务类型": "服务类型 ：<br/>02 门店寄件 ；<br/> 01 上门取件",
    serviceTypeCode: 'C01：国际件（International）<br/>C02：境内件（Domestic）',
    "派送类型": "派送类型：<br/>03 门店自提；<br/>04 派送上门",
    paymentMethod: "支付方式：<br/>PP_PM(“寄付月结”)",
    寄件信息对象: "寄件信息对象",
    收件信息对象: "收件信息对象",
    LC_pick_up_start_time: "物流公司上门取货开始时间 yyyy-MM-dd HH:mm:ss",
    CLC_door_to_door_end_time: "客户物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss",
    itemtType: "物品类型（对应订单主表物品类型）:<p>ITN1 服饰</p>  <p>ITN2 文件</p>  <p>ITN3 食品</p>  <p>ITN4  其他</p>  <p>ITN5  数码产品</p>  <p>ITN6  生活用品</p>  <p>ITN7 易碎品</p>",
    Length: "长，cm",
    Width: "宽，cm",
    Height: "高，cm",
    volume: "体积",
    Weight: "重量，单位kg，范围0.01-30",
    "包裹总件数": "包裹总件数",
    "包裹总票数": "包裹总票数(<=999)",
    "代收货款金额 (数值型)": "代收货款金额 (数值型)",
    "代收货款金额 (数值型)1": "代收货款金额 (条件必填,数值型)",
    collectionPayment: "代收货款币别（默认本国币别，如：SAR、AED、USD、RMB）",
    collectionPayment1: "代收货款币别（条件必填,默认本国币别，如：SAR、AED、USD、RMB）",
    offerFee: "保价金额(数值型),单位,如:SAR、AED、USD、RMB,(0~99999999,支持4位小数)",
    "保价费": "保价费",
    "备注": "备注",
    "商品信息列表": "商品信息列表",
    "客户信息": "客户信息",
    "寄件人姓名": "寄件人姓名",
    "卖家ID": "卖家ID",
    "寄件公司": "寄件公司",
    "寄件邮编": "寄件邮编",
    "寄件邮箱": "寄件邮箱",
    SendingMobilePhone: "寄件手机（手机和电话二选一必填）",
    SendingPhoneNumber: "寄件电话（手机和电话二选一必填）",
    ThreeCharacterSending: "寄件国家三字码（如：阿联酋=UAE、中国=CHN、沙特=KSA）",
    "寄件酋长国": "寄件省份",
    "寄件区域": "寄件城市",
    "区域1": "寄件区域",
    "寄件街道": "寄件街道",
    ShippingDetailedAddress: "寄件详细地址（寄件省份+城市+详细地址）",
    "寄件区号": "寄件区号",
    "收件人姓名": "收件人姓名",
    "收件人证件号码": "收件人证件号码",
    "收件公司": "收件公司",
    "收件邮编": "收件邮编",
    "收件邮箱": "收件邮箱",
    ReceivingMobilephone: "收件手机（手机和电话二选一必填）",
    ReceivingPhoneNumber: "收件电话（手机和电话二选一必填）",
    ThreeCharacterRecipient: "收件国家三字码（如：阿联酋=UAE、中国=CHN、沙特=KSA）<p>收件地址需与客户所属地一致</p>",
    "收件酋长国": "收件省份",
    "收件区域": "收件城市",
    "区域2": "收件区域",
    "收件街道": "收件街道",
    ReceivingDetailedAddress: "收件详细地址（收件省份+城市+详细地址）",
    "收件区号": "收件区号",
    物品类型: "物品类型: <p>ITN1 服饰</p>  <p>ITN2 文件</p>  <p>ITN3 食品</p>  <p>ITN4  其他</p>  <p>ITN5  数码产品</p>  <p>ITN6  生活用品</p>  <p>ITN7 易碎品</p>",
    "物品名称": "物品名称",
    "物品中文名称": "物品中文名称",
    "物品英文名称": "物品英文名称",
    cases: "件数，≤1",
    "是否代收货款": "是否代收货款<br/>1=是<br/>2=否",
    "件数范围": "件数范围1-999",
    "申报价值(数值型)": "申报价值(数值型) 单个物品价值",
    priceCurrency: "申报货款币别（默认本国币别，如：AED）） 单个订单申报币别不可不一致",
    "物品描述": "物品描述",
    '退换货': '1：退货 </br > 2：退换货',
    '退货单单号': '退货单单号',
    '换货单单号': '换货单单号(当 returnAndExchangeType 是 2 时返回)',
    "商品URL": "商品URL",
    "货物数量 跨境件报关需要填写": "货物数量 跨境件报关需要填写",
    货物单位: "货物单位，如：个、台、本， 跨境件报关需要填写",
    原产地国别: "原产地国别， 跨境件报关需要填写",
    货物产品国检备案编号: "货物产品国检备案编号 跨境件报关需要填写",
    商品海关备案号: "商品海关备案号 跨境件报关需要填写",
    商品行邮税号: "商品行邮税号 跨境件报关需要填写",
    海关编码: "海关编码 跨境件报关需要填写",
    商品编号: "商品编号 跨境件报关需要填写",
    货物品牌: "货物品牌 跨境件报关需要填写",
    货物规格型号: "货物规格型号 跨境件报关需要填写",
    生产厂家: "生产厂家 跨境件报关需要填写",
    托寄物声明价值: "托寄物声明价值 跨境件报关需要填写",
    托寄物声明价值币别: "托寄物声明价值币别 跨境件报关需要填写",
    客户支付的运费: "客户支付的运费 跨境件报关需要填写",
    "返回码，见附录": "返回码，见附录",
    "业务数据": "业务数据",
    "集包地": "集包地",
    "返回客户订单号": "返回客户订单号",
    "订单创建时间": "订单创建时间 yyyy-MM-dd HH:mm:ss",
    "三段码online": "三段码（获取到三段码优先返回三段码，无三段码返回大头笔）",
    "参考总运费": "参考总运费（数值型）",
    "查询命令": "查询命令 1.按客户订单编号查询   2.按运单编号查询（用运单号查订单状态）   3.按下单时间段查询（查订单）（按时间段查询返回不限制条数）  4.订单编号",
    command: "command=1 客户订单编号查询 ;command=2 运单编号暂时;command=4订单号（公司内部）支持200个; Command=1、2或3时必填",
    startDate: "开始时间(24小时制: yyyy-MM-dd HH:mm:ss)（command为3时必填）（客户下单时间）command = 3 时必填",
    endDate: "结束时间(24小时制: yyyy-MM-dd HH:mm:ss)（command为3时必填），时间范围最大7天command = 3 时必填",
    status: "状态（订单状态取下方状态表，筛选数据使用，默认全部）:<br/>已取消 104 ;<br/>已取件 103 ;<br/>已调派业务员 102 ;<br/>已调派网点 101 ;<br/>未调派 100",
    "command = 3 时必填": "command = 3 时必填",
    系统订单号: "系统订单号",
    "客户订单号-客户自己系统的订单号": "客户订单号    客户自己系统的订单号",
    订单状态: "订单状态 ：<br/>已取消 104 ；<br/>已取件 103 ；<br/>已调派业务员 102 ；<br/>已调派网点 101 ；<br/>未调派 100",
    订单类型: "订单类型  ：<br/>01散客 <br/> 02月结",
    三段码: "三段码",
    "客户编码（订单类型传2时，必填）": "客户编码（订单类型传2时，必填）",
    "订单类型  1（散客），2（协议客户），3（出口国际件）": "订单类型 <br/> 1（散客），<br/>2（协议客户），<br/>3（出口国际件）",
    "取消原因": "取消原因",
    "退件原因": "退件原因",
    "运单号": "运单号",
    "更新订单时，必传": "更新订单时，必传",
    "客户订单号": "客户订单号",
    operateType: "事件，客户填写“新增”则进行订单新增，；客户传“更新”，则进行订单更新<p>1 新增</p><p>2 修改</p>",
    客户订单编号: "客户订单编号",
    极兔运单编号: "极兔运单编号",
    "网点名称（“已调派业务员”回传）": "网点名称（“已调派业务员”回传）",
    "业务员名称（“已调派业务员”回传）": "业务员名称（“已调派业务员”回传）",
    "业务员联系方式（“已调派业务员”回传）": "业务员联系方式（“已调派业务员”回传）",
    极兔订单编号: "极兔订单编号",
    "重量（“已揽收”“已取件”时回传）": "重量（“已揽收”“已取件”时回传）",
    "订单取消原因（“已取消”时回传）": "订单取消原因（“已取消”时回传）",
    "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)": "状态(“已调派业务员”,“已揽收”，“已取件”，“已取消”)",
    "时间": "时间",
    承运商编码: "承运商编码",
    "业务员编码（联系出货网点提供，且采用网点编码签名）": "业务员编码（联系出货网点提供，且采用网点编码签名）",
    "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写": "签名，Base64(Md5(客户编码/业务员编码+密文+privateKey))，其中密文：MD5(明文密码/网点编码+jadada236t2) 后大写",
    运单编号: "运单编号",
    "快件类型：EZ(标准快递)": "快件类型：EZ(标准快递)",
    "订单类型  1、散客；": "订单类型  1、散客；",
    "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）": "支付方式CC_CASH(“到付现结”);PP_CASH（“寄付现结”）",
    "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss": "物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss",
    "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单": "运单号，多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单",
    运单轨迹详情: "运单轨迹详情",
    扫描时间: "扫描时间",
    轨迹描述:  "轨迹描述",
    scanType: "扫描类型 <p>10：快件揽收</p> <p>50：发件扫描</p> <p>92：到件扫描</p> <p>90：中心到件</p> <p>94：派件扫描</p>  <p>100：快件签收</p> <p>110：问题件扫描</p> <p>172：退件扫描</p> <p>402：改地址扫描</p> <p>1001：退件签收</p> <p>301：国际件入仓</p> <p>302：国际航空到件</p> <p>303：国际航空发件</p> <p>304：报关扫描</p> <p>305：清关扫描</p>",
    scanTypeCode: "扫描类型code",
    扫描网点名称: "扫描网点名称",
    扫描网点ID: "扫描网点ID",
    业务员姓名: "业务员姓名",
    业务员联系方式: "业务员联系方式",
    扫描网点联系方式: "扫描网点联系方式",
    扫描网点省份: "扫描网点省份",
    扫描网点城市: "扫描网点城市",
    "扫描网点区/县": "扫描网点区/县",
    "上一站(到件)或下一站名称(发件)": "上一站(到件)或下一站名称(发件)",
    "下一站省份（发件扫描类型时提供）": "下一站省份（发件扫描类型时提供）",
    "下一站城市（发件扫描类型时提供）": "下一站城市（发件扫描类型时提供）",
    "下一站区/县（发件扫描类型时提供）": "下一站区/县（发件扫描类型时提供）",
    "签收图片（签收扫描时，展示该数据）":"签收图片（签收扫描时，展示该数据）",
    "电子签名（签收扫描时，展示该数据）":"电子签名（签收扫描时，展示该数据）",
    快递轨迹详情: "快递轨迹详情",
    "订阅节点": "订阅节点：10&50&92&90&94&100&110&172&402&1001&301&302&303&304&305 <p>10：快件揽收</p> <p>50：发件扫描</p> <p>92：到件扫描</p> <p>90：中心到件</p> <p>94：派件扫描</p>  <p>100：快件签收</p> <p>110：问题件扫描</p> <p>172：退件扫描</p> <p>402：改地址扫描</p> <p>1001：退件签收</p> <p>301：国际件入仓</p> <p>302：国际航空到件</p> <p>303：国际航空发件</p> <p>304：报关扫描</p> <p>305：清关扫描</p>",
    数组: "数组",
    "明文密码:H5CD3zE6": "明文密码:H5CD3zE6",
    "电子面单标签": "电子面单标签",
    "电子面单链接": "电子面单链接",
    "平台名称":"平台名称",
    "客户账户":"客户账户",
    isUnpackEnabled: "是否允许客户开箱验视<p>0 否</p><p>1 是</p>",
    needLogo: '0: 需要 <br /> 1:不需要',
    寄件经度: '寄件经度',
    寄件纬度: '寄件纬度',
    收件经度: '收件经度',
    收件纬度: '收件纬度',
    "经度（在问题件扫描时回传）": '经度（在问题件扫描时回传）',
    "纬度（在问题件扫描时回传）": '纬度（在问题件扫描时回传）',
    "OTP验证码（签收扫描类型时提供）": 'OTP验证码（签收扫描类型时提供）',
    商户号: '商户号',
    "快件预报接口": "用于跨境客户，同步发货批次中快件信息，例如：航空/陆运主单信息、包号、快件单号信息等。在库区完成货物分拣，打包称重、航空订舱后，通过接口回传相关批次内的货物信息。",
    "航空主单号": "航空主单号",
    "托盘号": "托盘号",
    "包号": "包号",
    "包重量": "包重量",
    "封包时间": "封包时间",
    "包列表": "包列表",
    "航空预报接口": "用于跨境客户，同步发货批次的航空、陆运、海运信息。再完成订舱获取到承运商的班次信息后，通过接口同步末端J&T Express，方便末端即使安排清关、尾派货。",
    "航空主单号陆运主单号": "航空主单号/陆运主单号",
    "航班号": "航班号",
    "航班日期": "航班日期",
    "航班预计起飞时间": "航班预计起飞时间",
    "航班预计到达时间": "航班预计到达时间",
    "航班实际起飞时间": "航班实际起飞时间",
    "航班实际到达时间": "航班实际到达时间",
    "运送重量": "运送重量",
    "起始地国家": "起始地国家 <br /> 1. KSA <br /> 2. UAE <br /> 3. CHN",
    "目的地国家": "目的地国家 <br /> 1. KSA <br /> 2. UAE <br /> 3. CHN",
    "起始地机场": "起始地机场",
    "目的地机场": "目的地机场",
    "目的港": "目的港 <br /> DMM <br /> JED <br /> RUH <br />DXB",
    "删除类型": "删除类型 <br /> PALLET：托盘 <br /> PACKAGE_INFO ：包信息 <br /> ORDER：订单",
    "批次号（快件预报删除）": "批次号（type为PALLET 、PACKAGE_INFO必填）",
    "托盘号（快件预报删除）": "托盘号（type为PALLET、PACKAGE_INFO 必填）",
    "包号（快件预报删除）": "包号（type为PACKAGE_INFO 必填）",
    "运单号（快件预报删除）": "运单号（type为ORDER 必填）",
    "快件预报删除接口": "使用该接口删除快件预报中提交的信息",
    "托盘列表": "托盘列表",
    "订单列表": "订单列表",
    签名类型: '签名类型 1.MD5(默认) 2.SHA256',
    "问题件图片（在问题件扫描时提供）": "问题件图片（在问题件扫描时提供）",
    "问题件二级编码": '问题件二级编码',
    '预估运费查询': '预估运费查询',
    '预估运费查询说明': '通过收寄件地址及物品信息预估运费',
    '⻓，cm': '⻓，cm',
    '宽，cm': '宽，cm',
    '⾼，cm': '⾼，cm',
    '重量': '重量（正数），单位kg，范围0.01-30，为空默认0.02',
    '运费总价（单位：元），保留两位⼩数': '运费总价（单位：元），保留两位⼩数',
    "subscribeDesc": "开放平台⽤户根据apiaccount订阅需要接收代收货款的客户编码",
    "subscribeOtherDesc": "推送财务结算的代收货款内容给到客户，客户需要在开放平台配置回传地址。",
    '登记时间': '登记时间',
    '订单流水号': '订单流水号',
    '返款进度': '返款进度\n1:待申请\n2:待审核\n3:待返款\n4:已返款',
    '应付客户货款⾦额': '应付客户货款⾦额',
    '总运单票数': '总运单票数',
    '运单列表信息': '运单列表信息',
    "到件图片（到件扫描时，展示该数据，多张图片以逗号分割）": '到件图片（到件扫描时，展示该数据，多张图片以逗号分割）',
    "计费重量": "计费重量",
    "包裹总长": "包裹总长",
    "包裹总宽": "包裹总宽",
    "包裹总高": "包裹总高",
    "预约派送日期": "预约派送日期",
    "预约派送时间段": "预约派送时间段",
    "国家三字码": "国家三字码",
    "省份": "省份",
    "城市": "城市",
    "区域": "区域",
    "详细地址": "详细地址",
    "true 成功 false 失败": "true 成功 false 失败",
    "客户可通过此接口进行预约派送": "客户可通过此接口进行预约派送",
    OrderDescription_10: "与平台签约的客户，可通过此接口创建出口国际件订单。",
    '业务参数，各接口的入参json报文': '业务参数，各接口的入参json报文',
    '默认C03-出国国际件': '默认C03-出国国际件',
    CharacterSending: '寄件国家二/三字码(阿联酋=AE/UAE)-只支持阿联酋',
    CharacterRecipient: '收件国家二字码',
    '数量': '数量',
    'purposeOfShipment': '发货目的（如1、2、3）<br/>1映射Gift<br/>2映射Personal not for sale<br/>3映射General Items',
    '原产地': '原产地',
    internationalExportExpressType: '仅支持ExportUAE',
    寄件建筑物编号: '寄件建筑物编号',
    寄件辅助编号: '寄件辅助编号',
    寄件短地址: '寄件短地址(条件必填，当寄件国家为SA或KSA时，短地址必填)',
    收件建筑物编号: '收件建筑物编号',
    收件辅助编号: '收件辅助编号',
    收件短地址: '收件短地址(条件必填，当收件国家为SA或KSA时，短地址必填)',
    客户编码: '客户编码',
    清关服务: '清关服务',
    清关小包下发: '清关小包下发',
    '下发清关小包信息接口（运单号需要先从订单创建接口获取）': '下发清关小包信息接口（运单号需要先从订单创建接口获取）',
    时间戳: '时间戳',
    '客户订单号（包裹号）': '客户订单号（包裹号）',
    收件人名称: '收件人名称',
    收件国家: '收件国家',
    收件人详细地址: '收件人详细地址',
    收件人手机号: '收件人手机号',
    收件人电话: '收件人电话',
    收件人ID信息: '收件人ID信息',
    收件人ID有效截止日期: '收件人ID有效截止日期',
    收件人生日: '收件人生日',
    收件人国籍: '收件人国籍',
    寄件人名称: '寄件人名称',
    寄件国家: '寄件国家',
    寄件人详细地址: '寄件人详细地址',
    寄件人手机号: '寄件人手机号',
    寄件人电话: '寄件人电话',
    '寄件公司（高价值必填）': '寄件公司（高价值必填）',
    申报币种: '申报币种',
    包裹重量: '包裹重量',
    物品明细: '物品明细',
    物品单价: '物品单价',
    '物品单重（单个物品的重量）': '物品单重（单个物品的重量）',
    海关申报编码: '海关申报编码',
    类目id: '类目id',
    sku: 'sku',
    '操作结果,1请求成功，0失败': '操作结果,1请求成功，0失败',
    '错误码': '错误码',
    清关单下发: '清关单下发',
    下发清关单相关信息: '下发清关单相关信息',
    提单号: '提单号',
    关务提单号: '关务提单号',
    运输工具代码: '运输工具代码',
    始发地港口代码: '始发地港口代码',
    目的地港口代码: '目的地港口代码',
    始发地城市代码: '始发地城市代码',
    目的地城市代码: '目的地城市代码',
    目的地国家代码: '目的地国家代码',
    预计离开时间: '预计离开时间',
    预计抵达时间: '预计抵达时间',
    箱数: '箱数',
    提单扫描件: '提单扫描件',
    关系list: '关系list',
    大包号: '大包号',
    小包号: '小包号',
    清关单取消: '清关单取消',
    '取消申报清关单，申报开始前支持取消': '取消申报清关单，申报开始前支持取消',
    清关单查询: '清关单查询',
    '支持查询清关单对应的提单状态及小包(运单)状态信息': '支持查询清关单对应的提单状态及小包(运单)状态信息',
    '业务数据（提单号、运单号、大包号）': '业务数据（提单号、运单号、大包号）',
    提单状态code: '提单状态code',
    提单状态: '提单状态',
    大包对象集合: '大包对象集合',
    '大包对象说明<BillLadingRelationVO>': '大包对象说明<BillLadingRelationVO>',
    小包集合: '小包集合',
    '小包对象说明<CustomsPackageRelationVO>': '小包对象说明<CustomsPackageRelationVO>',
    运单状态code: '运单状态code',
    运单状态: '运单状态',
    "业务枚举": "业务枚举 ：<br/>1代表提单号；2代表大包号；3代表运单号",
    '默认：AIR_TRANSPORT': '默认：AIR_TRANSPORT',
    "目的地国家代码KSA": "KSA 、 UAE 、 JOR 、 KWT",
    PDF的base64格式: 'PDF的base64格式',
    itemList类型说明: 'itemList类型说明',
    tiesList类型说明: 'tiesList类型说明',
    返回码: '返回码'
  },
  apiTestDoc: {
    接口说明: "接口说明",
    Headers: "Headers",
    Body: "Body",
    Response: "Response",
    错误代码: "错误代码",
    错误编码: "错误编码",
    错误描述: "错误描述",
    请求头Headers参数: "请求头Headers参数",
    不能为空: "不能为空",
    参数: "参数",
    业务参数签名失败: "业务参数签名失败",
    修改订单失败: "修改订单失败",
    区域不合法: "区域不合法",
    城市不合法: "城市不合法",
    省份不合法: "省份不合法",
    查不到数据: "查不到数据",
    下单失败: "下单失败",
    发件人信息不全: "发件人信息不全",
    "订单重复,无需重复下单！": "订单重复,无需重复下单！",
    收件人信息不全: "收件人信息不全",
    电话号码不能为空: "电话号码不能为空",
    地址信息不全: "地址信息不全",
    "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法": "请检查订单类型、服务类型、派送类型、物品类型、快件类型、结算方式是否合法",
    "请检查服务类型是否合法值为 01或 02": "请检查服务类型是否合法值为 01或 02",
    上门服务时间信息不全: "上门服务时间信息不全",
    重量信息不合法: "重量信息不合法",
    物品信息不全: "物品信息不全",
    物品名称不全: "物品名称不全",
    物品类型不全: "物品类型不全",
    "客户订单号已存在,无法下单！": "客户订单号已存在,无法下单！",
    姓名信息非法: "姓名信息非法",
    公司信息过长: "公司信息过长",
    联系信息过长: "联系信息过长",
    邮编或邮箱信息非法: "邮编或邮箱信息非法",
    价格信息非法: "价格信息非法",
    "备注、描述、链接信息非法": "备注、描述、链接信息非法",
    地址信息过长: "地址信息过长",
    街道信息过长: "街道信息过长",
    包裹总件数无效: "包裹总件数无效",
    暂未开通代收货款业务: "暂未开通代收货款业务",
    "支付方式不匹配,PP_CASH,CC_CASH,PP_MM": "支付方式不匹配,PP_CASH,CC_CASH,PP_MM",
    "已取件状态不可修改": "已取件状态不可修改",
    "已取消状态不可修改": "已取消状态不可修改",
    "更新订单失败，请稍后重试！": "更新订单失败，请稍后重试！",
    "始发地信息不全": "始发地信息不全",
    "收货地信息不全": "收货地信息不全",
    "暂未开通保价服务": "暂未开通保价服务",
    "保价金额需大于等于0": "保价金额需大于等于0",
    "时间范围非法": "时间范围非法",
    "页码非法": "页码非法",
    "超过数据限制": "超过数据限制",
    "客户订单号不能为空或过长": "客户订单号不能为空或过长",
    "取消原因不能为空": "取消原因不能为空",
    运单号非法: "运单号非法",
    运单号个数超过30: "运单号个数超过30",
    运单号个数超过1000: "运单号个数超过1000",
    物品数量非法: "物品数量非法",
    非法金额: "非法金额",
    "必填参数为空": "必填参数为空",
    '总数量不能超过 999': '总数量不能超过 999',
    '客户编码不合法': '客户编码不合法',
    '发件人信息不完整': '发件人信息不完整',
    '收件人信息不完整': '收件人信息不完整',
    '手机号码长度错误': '手机号码长度错误',
    '请填写正确的寄件省份': '请填写正确的寄件省份',
    'COD代收货款不能超过3万': 'COD代收货款不能超过3万',
    '货到付款金额不能小于': '货到付款金额不能小于 0.01',
    '货品类型信息不完整': '货品类型信息不完整',
    '请检查服务类型是否合法（仅支持 01 或 02）': '请检查服务类型是否合法（仅支持 01 或 02）',
    '请填写正确的派送类型': '请填写正确的派送类型',
    '请填写正确的运输类型': '请填写正确的运输类型',
    '快递类型错误': '快递类型错误',
    '服务类型代码校验失败': '服务类型代码校验失败',
    '仓库标识错误': '仓库标识错误',
    '条码不能为空': '条码不能为空',
    '商品编码不能为空': '商品编码不能为空',
    'SKU 编码不能为空': 'SKU 编码不能为空',
    '参数长度超过最大限制': '参数长度超过最大限制',
    '运费不能小于 0': '运费不能小于 0',
    '运费不合法': '运费不合法',
    '收货地址与客户所在位置不一致': '收货地址与客户所在位置不一致',
    '未找到收件人国家': '未找到收件人国家',
    '币种不合法': '币种不合法',
    '订单申报币种不匹配': '订单申报币种不匹配',
    '寄件国家编码或者名称不能为空': '寄件国家编码或者名称不能为空',
    '高价值包裹必须填写收件人证件号码': '高价值包裹必须填写收件人证件号码',
    '订单申报币种': '订单申报币种',
    '货物寄送目的填写错误': '货物寄送目的填写错误'
  },
  ...lang,
};

export default messages;
